module.exports = __webpack_public_path__ + "img/rainy.84cd4e7a.png";